import { Component, Inject, Input } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { LuModalConfig } from './lu-modal.models';

@Component({
	// eslint-disable-next-line @angular-eslint/component-selector
	selector: 'lu-modal',
	templateUrl: './lu-modal.component.html',
	styleUrls: ['./lu-modal.component.scss']
})
export class LuModalComponent {
	@Input() options: LuModalConfig = {} as LuModalConfig;

	constructor(@Inject(BsModalRef) private bsModalRef: BsModalRef) {}

	onClose(): void {
		if (this.options.close) {
			this.options.close();
		} else {
			this.bsModalRef.hide();
		}
	}
}
